import {
  GET_AB_WORK_REPORTING_MAPPING,
  GET_AB_WORK_REPORTING_ENTRIES,
  CREATE_AB_WORK_REPORTING_ENTRY,
  UPDATE_AB_WORK_REPORT_ENTRY,
  GET_AB_WORK_REPORTING_BATCHES,
  BATCH_AB_WORK_REPORTING_ENTRIES,
  ACCEPT_REJECT_AB_WORK_REPORTING_WORKSHEETS,
  GET_SAVED_AB_WORK_REPORT_FILTERS,
  CREATE_SAVED_AB_WORK_REPORT_FILTER,
  UPDATE_SAVED_AB_WORK_REPORT_FILTER,
  DELETE_SAVED_AB_WORK_REPORT_FILTER,
  SET_FAVORITE_AB_WORK_REPORT_FILTER,
  GET_AB_WORK_REPORTING_DISPLAY_FIELDS,
  SAVE_AB_WORK_REPORTING_DISPLAY_FIELDS,
  GET_AB_WORK_REPORTING_JOB_CODES,
  CREATE_AB_WORK_REPORTING_JOB_CODE,
  UPDATE_AB_WORK_REPORTING_JOB_CODE,
  DELETE_AB_WORK_REPORTING_JOB_CODE,
} from '../../state/actionTypes';

const initialState = {
  mapping: null,
  entries: [],
  batches: [],
  savedFilters: [],
  displayFields: {},
  jobCodes: [],
};

const getEntryStatus = ({
  entry,
  acceptedSet,
  rejectedSet,
  pendingSet,
}) => {
  if (acceptedSet.has(entry.id)) return 'Accepted';
  if (pendingSet.has(entry.id)) return 'Pending';
  if (rejectedSet.has(entry.id)) return 'Active';
  return entry.status;
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_AB_WORK_REPORTING_MAPPING:
      return { ...state, mapping: action.payload };
    case GET_AB_WORK_REPORTING_ENTRIES:
      return { ...state, entries: action.payload };
    case CREATE_AB_WORK_REPORTING_ENTRY:
      return { ...state, entries: [...state.entries, ...action.payload] };
    case GET_AB_WORK_REPORTING_BATCHES:
      return { ...state, batches: action.payload };
    case BATCH_AB_WORK_REPORTING_ENTRIES: {
      const {
        payload: entryIds = [],
      } = action;
      const entryIdSet = new Set(entryIds);
      return {
        ...state,
        entries: state.entries.map((entry) => ({
          ...entry,
          status: entryIdSet.has(entry.id) ? 'Exported' : entry.status,
        })),
      };
    }
    case UPDATE_AB_WORK_REPORT_ENTRY: {
      const {
        id,
        comments,
        quantity,
        entryStatus,
        dateWorked,
        bidItemId,
        segmentId,
      } = action.payload;

      const newEntry = {};
      if (comments !== undefined) newEntry.comments = comments;
      if (quantity !== undefined) newEntry.quantity = quantity;
      if (entryStatus !== undefined) newEntry.status = entryStatus;
      if (dateWorked !== undefined) newEntry.dateWorked = dateWorked;
      if (bidItemId !== undefined) newEntry.bidItemId = bidItemId;
      if (segmentId !== undefined) newEntry.segmentId = segmentId;
      return {
        ...state,
        entries: state.entries.map(
          (entry) => (entry.id === id
            ? { ...entry, ...newEntry }
            : entry)
        ),
      };
    }
    case ACCEPT_REJECT_AB_WORK_REPORTING_WORKSHEETS: {
      const {
        payload: {
          acceptedWorksheetEntries,
          rejectedWorksheetEntries,
          pendingWorksheetEntries,
        } = {},
      } = action;

      const acceptedSet = new Set(acceptedWorksheetEntries);
      const rejectedSet = new Set(rejectedWorksheetEntries);
      const pendingSet = new Set(pendingWorksheetEntries);

      const newEntries = [...state.entries || []].map((entry) => ({
        ...entry,
        status: getEntryStatus({
          entry,
          acceptedSet,
          rejectedSet,
          pendingSet,
        }),
      }));

      return { ...state, entries: newEntries };
    }
    case GET_SAVED_AB_WORK_REPORT_FILTERS:
      return { ...state, savedFilters: action.payload };
    case CREATE_SAVED_AB_WORK_REPORT_FILTER:
      return { ...state, savedFilters: [...state.savedFilters, action.payload] };
    case UPDATE_SAVED_AB_WORK_REPORT_FILTER:
      return {
        ...state,
        savedFilters: state.savedFilters.map(
          (filter) => (
            filter.id === action.payload.id
              ? { ...filter, ...action.payload }
              : filter
          )) };
    case DELETE_SAVED_AB_WORK_REPORT_FILTER:
      return {
        ...state,
        savedFilters: state.savedFilters.filter((filter) => filter.id !== action.payload.id),
      };
    case SET_FAVORITE_AB_WORK_REPORT_FILTER: {
      const { id, isFavorite } = action.payload;
      return {
        ...state,
        savedFilters: state.savedFilters.map((filter) => {
          if (filter.id === id) return { ...filter, isFavorite };
          // Only one favorite is allowed, so clear the others when setting one.
          if (isFavorite && filter.isFavorite) return { ...filter, isFavorite: false };
          return filter;
        }),
      };
    }
    case GET_AB_WORK_REPORTING_DISPLAY_FIELDS:
    case SAVE_AB_WORK_REPORTING_DISPLAY_FIELDS:
      return { ...state, displayFields: action.payload };
    case GET_AB_WORK_REPORTING_JOB_CODES:
      return { ...state, jobCodes: action.payload };
    case CREATE_AB_WORK_REPORTING_JOB_CODE:
      return { ...state, jobCodes: [...state.jobCodes, action.payload] };
    case UPDATE_AB_WORK_REPORTING_JOB_CODE: {
      const {
        name,
        payload = {},
      } = action.payload;
      return {
        ...state,
        jobCodes: state.jobCodes.map((jobCode) => (
          jobCode.name === name ? { ...jobCode, ...payload } : jobCode
        )),
      };
    }
    case DELETE_AB_WORK_REPORTING_JOB_CODE:
      return {
        ...state,
        jobCodes: state.jobCodes.filter((jobCode) => jobCode.name !== action.payload.name),
      };
    default:
      return state;
  }
};
